import { Divider, ListItem, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import { Fragment, memo, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';

interface Props {
  onClick: (event: MouseEvent<HTMLElement>) => void;
  onClose: (event: MouseEvent) => void;
  submenuAnchor: Element | null;
  isSubmenuVisible: boolean;
}

const SubscriptionAireTransferMenuComponent = ({
  onClick,
  onClose,
  isSubmenuVisible,
  submenuAnchor,
}: Props): React.ReactElement => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <ListItem onClick={onClick}>
        <ListItemText primary="Iscrizione AIRE per trasferimento da AIRE di altro comune" />
      </ListItem>
      <Menu
        id="subscription-aire-trasferimento-menu"
        anchorEl={submenuAnchor}
        open={isSubmenuVisible}
        onClose={onClose}
        PaperProps={{
          style: {
            width: '30ch',
          },
        }}
      >
        <MenuItem
          key="nuova-famiglia-trasferimento-menu-item"
          onClick={(event) => {
            onClose(event);
            navigate('/iscrizioni/aire-trasferimento-nuova');
          }}
        >
          <Typography variant="inherit">Istituzione nuova famiglia</Typography>
        </MenuItem>
        <Divider key="nuova-famiglia-trasferimento-divider" />
        <MenuItem
          key="aggregazione-trasferimento-menu-item"
          onClick={(event) => {
            onClose(event);
            navigate('/iscrizioni/aire-trasferimento-aggregazione');
          }}
        >
          <Typography variant="inherit">Aggregazione a famiglia</Typography>
        </MenuItem>
      </Menu>
    </Fragment>
  );
};

SubscriptionAireTransferMenuComponent.displayName = 'Subscription Aire Transfer Menu';

const SubscriptionAireTransferMenu = memo(SubscriptionAireTransferMenuComponent);

export default SubscriptionAireTransferMenu;
